import OtpInput from "react-otp-input";
import HeaderBar from "../../../../components/header/headerBar";
// import "../../../../assets/styles/admin/opd.scss";
import "../../../../assets/styles/admin/personcreate.scss";
import { EyeInvisibleFilled, EyeFilled } from "@ant-design/icons";
import MainButton from "../../../../components/button/mainButton";
import React, { useState, useRef, useEffect } from "react";
import EmptyModel from "../../../../components/modal/emptyModal";
import { getLocalUrl } from "../../../../functions";
import { useParams } from "react-router-dom";
import SelectField from "../../../../components/select/selectField";
import { Icon } from "@iconify/react";
import moment from "moment";
import axios from "axios";
import { useHistory } from "react-router-dom";

import { getFileHostUrl } from "../../../../helpers/functions";

import CountryPhoneInput, {
  CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd/dist/antd.css";
import "antd-country-phone-input/dist/index.css";

import {
  Select,
  Space,
  Checkbox,
  Input,
  Row,
  Col,
  Form,
  DatePicker,
  Button,
  Typography,
  Upload,
  InputNumber,
  message,
} from "antd";

interface Props {
  isHidel?: boolean;
}

interface ParamTypes {
  id: string;
}

const PersonnelcreateNew: React.FC<Props> = ({ isHidel = false }) => {
  let [fromCreatePersonnel] = Form.useForm();
  const { Text } = Typography;
  const history = useHistory();

  const { Option } = Select;
  const [status, setStatus] = useState("1");
  const [isOpen, setIsOpen] = useState(false);
  const [textModal, setTextModal] = useState("");
  const fileInput: any = useRef();
  const { id } = useParams<ParamTypes>();

  const [refNo, setRefNo] = useState<string>("");
  const [uploadFile, setUploadFile] = useState<any>([]);
  const [IsIdCardNumber, setIsIdCardNumber] = useState<string>("");

  const [options, setOptions] = useState<any>([]);
  const [selectProps, setSelectProps] = useState<any>([]);
  const [valueSelect, setValueSelect] = React.useState<any>([]);
  const [optionSelect, setOptionSelect] = React.useState<any>([]);

  const [optionGroup, setOptionGroup] = useState<any>([]);
  const [checkboxAddress, setCheckboxAddress] = useState<boolean>(false);

  const [optTitles, setOptTitles] = useState<any>([]);
  const [optBranch, setOptBranch] = useState<any>([]);
  const [optUseBranch, setOptUseBranch] = useState<any>([]);
  const [genderSelect, setGenderSelect] = useState<any>([]);
  const [optCountry, setOptCountry] = useState<any>([]);

  const [provinceOpt, setProvinceOpt] = useState<any>([]);
  const [provinceOpt1, setProvinceOpt1] = useState<any>([]);

  const [citiesOpt, setCitiesOpt] = useState<any>([]);
  const [citiesOpt1, setCitiesOpt1] = useState<any>([]);

  const [subCitiesOpt, setSubCitiesOpt] = useState<any>([]);
  const [subCitiesOpt1, setSubCitiesOpt1] = useState<any>([]);

  const [postalCodesOpt, setPostalCodesOpt] = useState<any>([]);
  const [postalCodesOpt1, setPostalCodesOpt1] = useState<any>([]);

  const [optUserGroup, setOptUserGroup] = useState<any>([]);

  const [isDisable, setIsDisable] = useState<any>([]);

  const [value1, setValue1] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [value2, setValue2] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [valuePhone1, setPhoneValue1] = useState<any>({});
  const [valuePhone2, setPhoneValue2] = useState<any>({});
  // check rule
  const [formFirstName, setformFirstName] = useState<string>("");
  const [formListName, setformListName] = useState<string>("");
  const [formNickName, setformNickName] = useState<string>("");
  const [formFirstNameENG, setformFirstNameENG] = useState<string>("");
  const [formListNameENG, setformListNameENG] = useState<string>("");
  const [formNickNameENG, setformNickNameENG] = useState<string>("");
  const [IdCardCheck, setformIdCardCheck] = useState<string>("");
  const [PassID, setformPassID] = useState<string>("");

  const dateFormat = "DD-MM-YYYY";
  let title = "CREATE PERSONNEL";

  function onClose() {
    setIsOpen(false);
  }

  const empty = [{ value: "", name: "" }];
  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {}
  function handleIDChange(otp: string) {
    setIsIdCardNumber(otp);
  }

  const onUploadIconClick = () => {
    console.log("click...");
    fileInput.current.click();
  };

  const onFileInputChange = (e: any) => {
    console.log("e change pic =>", e.file);
    const { originFileObj } = e.file;

    const url = getLocalUrl(originFileObj);
    if (e.file.status !== "removed") {
      setUploadFile([
        {
          uid: "1",
          name: e?.file?.name,
          url: url,
        },
      ]);
    } else {
      fromCreatePersonnel.setFieldsValue({ file: "" });
      setUploadFile([]);
    }
  };

  const getAPIs = () => {
    setRefNo("ENL58050001");
    setIsDisable({
      ...isDisable,
      city: true,
      subCity: true,
      postalCode: true,
      isUpload: true,
      city2: true,
      subCity2: true,
      postalCode2: true,
    });
    fromCreatePersonnel.setFieldsValue({ date: moment() });
  };

  const getBranches = async () => {
    await axios.get(`/branches`).then((res) => {
      let data = res?.data?.data;
      console.log("data branch", data);

      const optBranch = [];

      for (let i = 0; i < data?.length; i++) {
        optBranch.push(
          <Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Option>
        );
      }
      setOptBranch(optBranch);
    });

    setSelectProps({
      mode: "multiple" as const,
      style: { width: "100%" },
      options,
      onChange: (newValue: string[]) => {
        setValueSelect(newValue);
      },
      placeholder: "Select Item...",
      maxTagCount: "responsive" as const,
      showArrow: "showArrow",
    });
  };

  const getPrefixes = async () => {
    const titleName = await axios.get(`/prefixes`);
    const optTitleName = [];

    console.log("titleName", titleName?.data?.data);

    for (let i = 0; i < titleName?.data?.data.length; i++) {
      optTitleName.push(
        <Option
          value={titleName?.data?.data[i]?._id}
          key={titleName?.data?.data[i]?._id}
        >
          {titleName?.data?.data[i]?.name}
        </Option>
      );
    }
    setOptTitles(optTitleName);
  };
  const getGenders = async () => {
    await axios.get(`/genders`).then((res) => {
      console.log("res gender", res?.data?.data);

      const optGenders = [];
      for (let i = 0; i < res?.data?.data?.length; i++) {
        optGenders.push(
          <Option value={res?.data?.data[i]?._id} key={res?.data?.data[i]?._id}>
            {res?.data?.data[i]?.name}
          </Option>
        );
      }
      setGenderSelect(optGenders);
    });
  };

  const getProvinceThai = async () => {
    await axios.get(`/states`).then((res) => {
      let data = res?.data?.data;
      console.log("data states =>", data);
      const optProvince = [];
      for (let i = 0; i < data?.length; i++) {
        optProvince.push(
          <Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Option>
        );
      }
      setProvinceOpt(optProvince);
    });
  };

  const getCities = async (id: any, state: any) => {
    await axios.get(`/cities?stateId=${id}`).then((res) => {
      let data = res?.data?.data;
      console.log("res", data);
      const optcities = [];
      for (let i = 0; i < data?.length; i++) {
        optcities.push(
          <Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Option>
        );
      }

      if (state === "addIdCard") {
        setCitiesOpt(optcities);
      } else if (state === "addPresent") {
        setCitiesOpt1(optcities);
      }
    });
  };

  const getSubCities = async (id: any, state: any) => {
    await axios.get(`/sub-cities?cityId=${id}`).then((res) => {
      let data = res?.data?.data;
      console.log("res", data);
      const optsubcities = [];
      for (let i = 0; i < data?.length; i++) {
        optsubcities.push(
          <Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Option>
        );
      }
      if (state === "addIdCard") {
        setSubCitiesOpt(optsubcities);
      } else if (state === "addPresent") {
        setSubCitiesOpt1(optsubcities);
      }
    });
  };

  const getPostalCodes = async (id: any, state: any) => {
    console.log("id", id);

    await axios.get(`/postal-codes?cityId=${id}`).then((res) => {
      let data = res?.data?.data;
      console.log("res", data);
      const optpostalcode = [];
      for (let i = 0; i < data?.length; i++) {
        optpostalcode.push(
          <Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Option>
        );
      }
      if (state === "addIdCard") {
        setPostalCodesOpt(optpostalcode);
      } else if (state === "addPresent") {
        setPostalCodesOpt1(optpostalcode);
      }
    });
  };
  const getCountry = async () => {
    await axios.get(`/countries`).then((res) => {
      console.log("res country", res?.data?.data);
      const xdata = res?.data?.data;
      // console.log("country", Country);

      const optCountries = [];
      for (let i = 0; i < xdata.length; i++) {
        optCountries.push(
          <Option value={xdata[i]._id} key={xdata[i]._id}>
            {xdata[i].name}
          </Option>
        );
      }
      setOptCountry(optCountries);
      fromCreatePersonnel.setFieldsValue({
        country: optCountries,
        country2: optCountries,
      });
    });
  };
  const getPersonnelTypes = async () => {
    await axios.get(`/personnel-types`).then((res) => {
      const optPersonnelType = [];
      for (let i = 0; i < res?.data?.data?.length; i++) {
        optPersonnelType.push(
          <Option value={res?.data?.data[i]?._id} key={res?.data?.data[i]?._id}>
            {res?.data?.data[i]?.name}
            {/* <div
              onClick={() => {
                fromCreatePersonnel.setFieldsValue({
                  personnelType: "",
                });
                // console.log("_id", res?.data?.data[i]?._id);
                removePersonType(res?.data?.data[i]?._id);
              }}
            >
              <Icon
                icon="eva:close-circle-fill"
                color="#86CFC6"
                height="15"
                width="15"
              />
            </div> */}
          </Option>
        );
      }
      setPersonnelType(optPersonnelType);
      console.log("ressss ", res?.data?.data);
    });
  };
  const removePersonType = async (_id: any) => {
    console.log("_id", _id);

    await axios.delete(`/personnel-types/remove/${_id}`).then((res) => {
      fromCreatePersonnel.setFieldsValue({ personnelType: null });
      getPersonnelTypes();
    });
  };
  useEffect(() => {
    getAPIs();
    getPersonnelTypes();
    getBranches();
    getPrefixes();
    getProvinceThai();
    getGenders();
    getuserGroup();
    getCountry();
    getEnCode();
  }, []);
  // useEffect(() => {
  //   console.log(formFirstNameENG);
  // }, [formFirstNameENG]);

  const Onsubmit = async (values: any) => {
    try {
      console.log("values =>", values);
      values = {
        ...values,
        phoneNumbersFirst: valuePhone1,
        phoneNumbersSecond: valuePhone2,
      };
      // console.log("values 2++++=>", values);

      console.log("checkbox", checkboxAddress);
      // return;
      if (values.password !== values.confirmPassword) {
        message.error("Your Password Not Match");
        return;
      }
      let bodies = {};
      bodies = {
        ...values,
        address: {
          addressNumber: values?.addressNumber,
          buildingName: values?.buildingName,
          moo: values?.moo,
          soi: values?.soi,
          road: values?.road,
          country: values?.country[0]?.key,
          state: values?.state,
          city: values?.city,
          subCity: values?.subCity,
          postalCode: values?.postalCode,
        },
        isSameAddressIDCard: checkboxAddress,
        permission: values.permission,
        username: values.username,
        password: values.password,
      };
      // debugger;
      console.log("body =>", bodies);
      let body = { ...bodies };
      if (checkboxAddress === false) {
        // delete body.addressPresent;
        body = {
          ...bodies,
          addressCurrent: {
            addressNumber: values?.addressNumber2,
            buildingName: values?.buildingName2,
            moo: values?.moo2,
            soi: values?.soi2,
            road: values?.road2,
            country: values?.country2[0]?.key,
            state: values?.state2,
            city: values?.city2,
            subCity: values?.subCity2,
            postalCode: values?.postalCode2,
          },
        };
      }
      console.log("body after =>", body);

      const xDatas = await axios.post(`/users`, body !== "" ? body : bodies);

      console.log("xdatas", xDatas);

      const _id = xDatas?.data?.refUser?._id;
      const fmData = new FormData();
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      fmData.append("file", values?.file?.fileList[0]?.originFileObj);
      await axios.post(`/users/upload-profile/${_id}`, fmData, config);
      setTimeout(() => {
        message.success("บันทึกสำเร็จ/Create Success");
        history.push(`/setting/personnel`);
      }, 300);
    } catch (err) {
      console.log("error =>", err);
      message.error("เกิดข้อผิดพลาด Please Check Again");
      return;
    }
  };

  const findingDate = (values: any) => {
    console.log("values", values);

    let difference = moment().diff(values);
    let duration = moment.duration(difference);
    fromCreatePersonnel.setFieldsValue({
      year: duration.years() + " Y",
      day: duration.days() + " D",
      month: duration.months() + " M",
    });
  };
  const [personnelType, setPersonnelType] = useState<any>([]);
  const [name, setName] = useState("");
  const onNameChange = (e: any) => {
    setName(e.target.value);
  };

  const addItem = async (e: any) => {
    e.preventDefault();
    if (name !== "") {
      // console.log("e", typeof e);
      // console.log("name", name);
      await axios
        .post(`/personnel-types`, {
          name: name,
        })
        .then((res) => {
          getPersonnelTypes();
        });
    }
    // setItems([...items, name || `New item ${index++}`]);
    setName("");
  };
  const validate = (type: string) => {
    const xvalidate = {
      required: true,
      message: "INPUT " + type + " !",
    };
    return xvalidate;
  };
  const OnchangePic = (e: any) => {
    console.log("e", e.target);
  };
  const getuserGroup = async () => {
    await axios.get(`/permissions/get-permissions`).then((res) => {
      const datas = res?.data?.data;
      console.log("datas usergroup", datas);

      const UserGroup = [];
      for (let i = 0; i < datas.length; i++) {
        UserGroup.push(
          <Option value={datas[i]._id} key={datas[i]._id}>
            {datas[i].name}
          </Option>
        );
      }
      setOptUserGroup(UserGroup);
    });
  };
  const getEnCode = async () => {
    await axios.get(`/users/get-code`).then((res) => {
      const datas = res?.data?.code;
      console.log("datas", datas);

      fromCreatePersonnel.setFieldsValue({
        code: datas,
      });
    });
  };
  const onKeydownCheck = (eveb: KeyboardEvent) => {
    console.log("e event", eveb.which);
    if (eveb.which !== 8) {
      eveb.preventDefault();
      // message.error("Please Input Max 10 ");
    }
  };
  const onKeydownCheckSpaceBar = (eveb: KeyboardEvent) => {
    // console.log("e event", eveb.which);
    if (eveb.which === 32) {
      eveb.preventDefault();
      message.error("Please Use Anoter Letter");
    }
  };

  const checkValue1 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue1(body);
      }, 200);
    }
  };
  const checkValue2 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue2(body);
      }, 200);
    }
  };
  return (
    <div style={{ padding: "10px 40px" }}>
      <HeaderBar title={title} btnBack={true}></HeaderBar>
      <EmptyModel show={isOpen} onClose={onClose}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            height: "300px",
            paddingTop: "20px",
          }}
        >
          <Icon
            icon="mdi:check-circle-outline"
            color="#86CFC6"
            width="24"
            height="24"
          />

          <div className="col-12" style={{ textAlign: "center" }}>
            <div>บันทึกผู้ใช้งานระบบเรียบร้อยแล้ว</div>
            <div>User saved successfully.</div>
          </div>
          <MainButton
            className="mg-10"
            width="100px"
            title="Agree"
            onClick={() => setIsOpen(false)}
          />
        </div>
      </EmptyModel>
      <Form form={fromCreatePersonnel} onFinish={Onsubmit} layout="vertical">
        <div className="create-page-personel" style={{ padding: "30px 30px" }}>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <Form.Item label="EN" name="code" rules={[validate("EN")]}>
                <Input
                  className="input-personnel"
                  disabled
                  style={{ background: "#f3fffc" }}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="BRANCH"
                name="branch"
                rules={[validate("BRANCH")]}
              >
                <Select
                  className="antd-Selected"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optBranch}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="Personnel Types"
                name="personnelType"
                rules={[validate("Personnel Types")]}
              >
                <Select
                  // onChange={(e: any, $event: any) => {
                  //   console.log("$event =>", $event);
                  //   console.log("e =>", e);
                  // }}
                  className="antd-Selected"
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  dropdownRender={(menu) => (
                    <>
                      {menu}

                      <Space align="center" style={{ padding: "0 8px 4px" }}>
                        <Typography.Link
                          onClick={(e) => addItem(e)}
                          style={{ whiteSpace: "nowrap", color: "#86CFC6" }}
                        >
                          <Icon
                            icon="akar-icons:plus"
                            height="20"
                            width="20"
                            color="#86CFC6"
                          />
                        </Typography.Link>
                        <Input
                          placeholder="Add Type"
                          value={name}
                          onChange={onNameChange}
                        />
                      </Space>
                    </>
                  )}
                >
                  {personnelType}
                </Select>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label="DATE" name="date" rules={[validate("DATE")]}>
                <DatePicker
                  className="input-personnel"
                  // defaultValue={moment()}
                  value={moment()}
                  format={dateFormat}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ padding: "20px 0px" }}>
            <Col span={24}>
              <Form.Item
                label="BRANCH LICENSE"
                name="branchLicenses"
                rules={[validate("BRANCH LICENSE")]}
              >
                <Select
                  className="antd-Selected"
                  mode="multiple"
                  style={{ width: "100%" }}
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optBranch}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col>
              <h4 className="title-header">Personnel Information</h4>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={6} style={{ marginTop: "0px" }}>
              <Form.Item
                name="file"
                rules={[
                  {
                    required: true,
                    message: "Attach Picture!",
                  },
                ]}
              >
                <Upload
                  listType="picture-card"
                  onChange={(e) => {
                    console.log("e v1 =>", e);
                    if (e.fileList.length !== 0) {
                      setIsDisable({ ...isDisable, isUpload: false });
                    }
                    onFileInputChange(e);
                  }}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onRemove={(e) => {
                    console.log("e v2 =>", e);
                    setIsDisable({ ...isDisable, isUpload: true });
                  }}
                  fileList={uploadFile}
                  accept="image/*"
                >
                  {isDisable?.isUpload && (
                    <>
                      <Row justify="center">
                        <Col>
                          <Icon
                            icon="ic:round-add-photo-alternate"
                            color="#C4C4C4"
                            height="50"
                            width="50"
                          />
                        </Col>
                        <Col>
                          <Text
                            style={{ color: "#4d7e7f", fontSize: "12px" }}
                            strong
                          >
                            UPLOAD IMAGE
                          </Text>
                        </Col>
                      </Row>
                    </>
                  )}
                </Upload>
              </Form.Item>
            </Col>
            <Col span={18}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    name="prefix"
                    rules={[validate("คำนำหน้าชื่อ/TITLE")]}
                  >
                    <Select
                      className="antd-Selected"
                      placeholder="คำนำหน้าชื่อ/TITLE"
                      style={{ width: "100%" }}
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optTitles}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ marginTop: "40px" }}>
                <Col span={8}>
                  <Form.Item
                    name="firstName"
                    rules={[
                      {
                        required: formFirstNameENG !== "" ? false : true,
                        message: "INPUT ชื่อ/NAME !",
                      },
                      // validate("ชื่อ/NAME"),
                    ]}
                  >
                    <Input
                      className="input-personnel"
                      placeholder="ชื่อ/NAME"
                      onChange={(e) => {
                        setformFirstName(e.target.value);
                      }}
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="lastName"
                    rules={[
                      {
                        required: formListNameENG !== "" ? false : true,
                        message: "INPUT นามสกุล/SURNAME !",
                      },
                    ]}
                    // rules={[validate("นามสกุล/SURNAME")]}
                  >
                    <Input
                      className="input-personnel"
                      placeholder="นามสกุล/SURNAME"
                      onChange={(e) => {
                        setformListName(e.target.value);
                      }}
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="nickName"
                    rules={[
                      {
                        required: formNickNameENG !== "" ? false : true,
                        message: "INPUT ชื่อเล่น/NICKNAME !",
                      },
                    ]}
                    // rules={[validate("ชื่อเล่น/NICKNAME")]}
                  >
                    <Input
                      className="input-personnel"
                      placeholder="ชื่อเล่น/NICKNAME"
                      onChange={(e) => {
                        setformNickName(e.target.value);
                      }}
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
            <Col span={6}>
              <Form.Item
                name="firstNameEN"
                rules={[
                  // validate("NAME"),
                  {
                    required: formFirstName !== "" ? false : true,
                    message: "INPUT NAME !",
                  },
                ]}
              >
                <Input
                  className="input-personnel"
                  placeholder="NAME"
                  onChange={(e) => {
                    setformFirstNameENG(e.target.value);
                  }}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="middleNameEN">
                <Input
                  className="input-personnel"
                  placeholder="MIDDLE NAME"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="lastNameEN"
                rules={[
                  {
                    required: formListName !== "" ? false : true,
                    message: "INPUT SURNAME !",
                  },
                ]}
                // rules={[validate("SURNAME")]}
              >
                <Input
                  className="input-personnel"
                  placeholder="SURNAME"
                  onChange={(e) => {
                    setformListNameENG(e.target.value);
                  }}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="nickNameEN"
                rules={[
                  {
                    required: formNickName !== "" ? false : true,
                    message: "INPUT NICKNAME!",
                  },
                ]}
                // rules={[validate("NICKNAME")]}
              >
                <Input
                  className="input-personnel"
                  placeholder="NICKNAME"
                  onChange={(e) => {
                    setformNickNameENG(e.target.value);
                  }}
                ></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ paddingTop: "20px" }}>
            <span className="title-header idenNo">IDENTITY NO.</span>
          </Row>
          <Row gutter={[16, 16]} style={{ paddingTop: "10px" }}>
            <Col span={12}>
              <Form.Item
                name="idCard"
                rules={[
                  {
                    required: PassID !== "" ? false : true,
                    message: "กรุณากรอก idCard!",
                  },
                ]}
              >
                <OtpInput
                  inputStyle={{
                    border: "1px solid #aaa",
                    borderRadius: "5px",
                    width: "23px",
                    height: "23px",
                    fontSize: "12px",
                    background: "#f3fffc",
                    fontWeight: "400",
                  }}
                  isInputNum
                  // onChange={handleIDChange}
                  numInputs={13}
                  separator={<span style={{ width: "5px" }}></span>}
                  focusStyle={{
                    border: "1px solid #CFD3DB",
                    outline: "none",
                  }}
                  onChange={(e: any) => {
                    handleIDChange(e);
                    setformIdCardCheck(e);
                  }}
                  value={IsIdCardNumber}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="passportID"
                rules={[
                  {
                    required: IdCardCheck !== "" ? false : true,
                    message: "กรุณากรอก PASSPORT NO.!",
                  },
                ]}
              >
                <Input
                  className="input-personnel"
                  placeholder="Passport ID"
                  type="text"
                  onKeyDown={(e: any) => {
                    if (e.target.value.length >= 10) {
                      onKeydownCheck(e);
                    }
                  }}
                  onChange={(e: any) => {
                    setformPassID(e.target.value);
                  }}
                  // onChange={(e:any)=>{console.log();
                  // }}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="gender" rules={[validate("GENDER")]}>
                <Select
                  className="antd-Selected"
                  placeholder="GENDER"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {genderSelect}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
            <Col span={6}>
              <Form.Item name="height" rules={[validate("HEIGHT (cm.)")]}>
                <Input
                  className="input-personnel"
                  placeholder="HEIGHT (cm.)"
                  type="number"
                  onKeyDown={(e: any) => {
                    if (e.target.value.length > 2) {
                      onKeydownCheck(e);
                    }
                  }}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="weight" rules={[validate("WEIGHT (kg.)")]}>
                <Input
                  className="input-personnel"
                  placeholder="WEIGHT (kg.)"
                  type="number"
                  onKeyDown={(e: any) => {
                    if (e.target.value.length > 2) {
                      onKeydownCheck(e);
                    }
                  }}
                ></Input>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item name="birthDate" rules={[validate("BIRTH DATE")]}>
                <DatePicker
                  disabledDate={(d) => !d || d.isAfter(moment())}
                  format={dateFormat}
                  className="input-personnel"
                  placeholder="BIRTH DATE"
                  onChange={(e) => findingDate(e)}
                />
              </Form.Item>
            </Col>

            <Col span={2}>
              <Form.Item name="year">
                <Input
                  className="input-personnel"
                  style={{ textAlign: "center" }}
                  placeholder="YEAR"
                  readOnly
                ></Input>
              </Form.Item>
            </Col>
            <Col span={2}>
              <Form.Item name="month">
                <Input
                  className="input-personnel"
                  style={{ textAlign: "center" }}
                  placeholder="MONTH"
                  readOnly
                ></Input>
              </Form.Item>
            </Col>
            <Col span={2}>
              <Form.Item name="day">
                <Input
                  className="input-personnel"
                  style={{ textAlign: "center" }}
                  placeholder="DAY"
                  readOnly
                ></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col span={6}>
              {/* <Form.Item name="phoneNumbers" rules={[validate("MOBILE NO.")]}>
                <Select
                  className="antd-Selected"
                  mode="tags"
                  placeholder="MOBILE NO."
                  onKeyDown={(e: any) => {
                    if (e.target.value.length > 9) {
                      onKeydownCheck(e);
                    }
                  }}
                ></Select>
              </Form.Item> */}
              <Form.Item
                name="phoneNumbersFirst"
                className="selected-countrycode"
              >
                {/* <Select
                    mode="tags"
                    className="col-12"
                    placeholder="MOBILE NO.*"
                    onKeyDown={(e: any) => {
                      if (e.target.value.length > 9) {
                        onKeydownCheck(e);
                      }
                    }}
                  ></Select> */}
                {/* <Row justify="space-around">
                    <Col span={7}>
                      <Select
                        style={{ width: "100%" }}
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                      ></Select>
                    </Col>
                    <Col span={17}>
                      <Input></Input>
                    </Col>
                  </Row> */}
                <ConfigProvider locale={en}>
                  <CountryPhoneInput
                    type="number"
                    value={value1}
                    onChange={(v: any) => {
                      setValue1(v);
                      checkValue1(v);
                    }}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="phoneNumbersSecond"
                className="selected-countrycode"
              >
                <ConfigProvider locale={en}>
                  <CountryPhoneInput
                    type="number"
                    value={value2}
                    onChange={(v: any) => {
                      setValue2(v);
                      checkValue2(v);
                    }}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            </Col>
            <Col span={6} style={{ marginTop: "8px" }}>
              <Form.Item name="email" rules={[validate("E-MAIL")]}>
                <Input
                  type="email"
                  className="input-personnel"
                  placeholder="E-MAIL"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6} style={{ marginTop: "8px" }}>
              <Form.Item name="lineId" rules={[validate("LINE ID")]}>
                <Input
                  className="input-personnel"
                  placeholder="LINE ID"
                ></Input>
              </Form.Item>
            </Col>
          </Row>

          <div className="title-header">
            <h3 className="title-header">Address Information</h3>
          </div>

          <h5>Address as per ID Card (ที่อยู่ตามบัตรประชาชน)</h5>
          <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
            <Col span={6}>
              <Form.Item
                name="addressNumber"
                rules={[validate("Number/เลขที่")]}
              >
                <Input
                  className="input-personnel"
                  placeholder="Number/เลขที่"
                  type="number"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="buildingName"
                rules={[validate("building/ชื่ออาคาร")]}
              >
                <Input
                  className="input-personnel"
                  placeholder="building/ชื่ออาคาร"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="moo" rules={[validate("Village No./หมู่ที่")]}>
                <Input
                  className="input-personnel"
                  placeholder="Village No./หมู่ที่"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="soi" rules={[validate("Lane/ซอย")]}>
                <Input
                  className="input-personnel"
                  placeholder="Lane/ซอย"
                ></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
            <Col span={6}>
              <Form.Item name="road" rules={[validate("Road/ถนน")]}>
                <Input
                  className="input-personnel"
                  placeholder="Road/ถนน"
                ></Input>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="state" rules={[validate("Province/จังหวัด")]}>
                <Select
                  className="antd-Selected"
                  placeholder="Province/จังหวัด"
                  onChange={(e) => {
                    fromCreatePersonnel.setFieldsValue({
                      city: null,
                      subCity: null,
                      postalCode: null,
                    });
                    getCities(e, "addIdCard");
                    setIsDisable({
                      ...isDisable,
                      city: false,
                      subCity: true,
                      postalCode: true,
                    });
                  }}
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {provinceOpt}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="city"
                rules={[
                  {
                    required: !isDisable.city,
                    message: "กรุณากรอก District/เขต/อำเภอ!",
                  },
                ]}
              >
                <Select
                  className="antd-Selected"
                  placeholder="District/เขต/อำเภอ"
                  onChange={(e) => {
                    fromCreatePersonnel.setFieldsValue({
                      subCity: null,
                      postalCode: null,
                    });
                    getSubCities(e, "addIdCard");
                    getPostalCodes(e, "addIdCard");
                    setIsDisable({
                      ...isDisable,
                      subCity: false,
                      postalCode: true,
                    });
                  }}
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                  disabled={isDisable.city}
                >
                  {citiesOpt}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="subCity"
                rules={[
                  {
                    required: !isDisable.subCity,
                    message: "กรุณากรอก Sub-district/แขวง/ตำบล!",
                  },
                ]}
              >
                <Select
                  className="antd-Selected"
                  disabled={isDisable.subCity}
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  placeholder="Sub-district/แขวง/ตำบล"
                  onChange={(e) => {
                    fromCreatePersonnel.setFieldsValue({
                      postalCode: null,
                    });
                    setIsDisable({
                      ...isDisable,
                      postalCode: false,
                    });
                  }}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {subCitiesOpt}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
            <Col span={6}>
              <Form.Item
                name="postalCode"
                rules={[
                  {
                    required: !isDisable.postalCode,
                    message: "กรุณากรอกข้อมูล Postal Code/รหัสไปรษณีย์!",
                  },
                ]}
              >
                <Select
                  className="antd-Selected"
                  disabled={isDisable.postalCode}
                  placeholder="Postal Code/รหัสไปรษณีย์"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {postalCodesOpt}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="country" rules={[validate("Country/ประเทศ")]}>
                <Select
                  className="antd-Selected"
                  placeholder="Country/ประเทศ"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optCountry}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <h5 style={{ marginTop: "50px" }}>
            Present Address (ที่อยู่ปัจจุบัน)
          </h5>

          {/* <input type="checkbox" id="same" style={{ marginTop: "10px" }} 
          onChange={(e) => { console.log(e.target.value)}}
          value="true"
        /> */}
          <Checkbox
            onChange={(e) => {
              // checkAddress(e.target.checked);
              console.log("checkaddresss", e.target.checked);

              setCheckboxAddress(e.target.checked);
              fromCreatePersonnel.setFieldsValue({
                addressNumber2: null,
                buildingName2: null,
                moo2: null,
                soi2: null,
                road2: null,
                // country2: null,
                state2: null,
                city2: null,
                subCity2: null,
                postalCode2: null,
              });
            }}
          >
            <label htmlFor="same" style={{ marginLeft: "10px" }}>
              เหมือนที่อยู่ตามบัตรประชาชน/Same as the address on the ID card
            </label>
          </Checkbox>

          {!checkboxAddress && (
            <>
              <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
                <Col span={6}>
                  <Form.Item
                    name="addressNumber2"
                    rules={[validate("Number/เลขที่")]}
                  >
                    <Input
                      className="input-personnel"
                      placeholder="Number/เลขที่"
                      type="number"
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="buildingName2"
                    rules={[validate("building/ชื่ออาคาร")]}
                  >
                    <Input
                      className="input-personnel"
                      placeholder="building/ชื่ออาคาร"
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="moo2"
                    rules={[validate("Village No./หมู่ที่")]}
                  >
                    <Input
                      className="input-personnel"
                      placeholder="Village No./หมู่ที่"
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="soi2" rules={[validate("Lane/ซอย")]}>
                    <Input
                      className="input-personnel"
                      placeholder="Lane/ซอย"
                    ></Input>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
                <Col span={6}>
                  <Form.Item name="road2" rules={[validate("Road/ถนน")]}>
                    <Input
                      className="input-personnel"
                      placeholder="Road/ถนน"
                    ></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="state2"
                    rules={[validate("Province/จังหวัด")]}
                  >
                    <Select
                      className="antd-Selected"
                      placeholder="Province/จังหวัด"
                      onChange={(e) => {
                        fromCreatePersonnel.setFieldsValue({
                          city2: null,
                          subCity2: null,
                          postalCode2: null,
                        });
                        getCities(e, "addPresent");
                        setIsDisable({
                          ...isDisable,
                          city2: false,
                          subCity2: true,
                          postalCode2: true,
                        });
                      }}
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {provinceOpt}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="city2"
                    rules={[
                      {
                        required: !isDisable.subCity,
                        message: "กรุณากรอก District/เขต/อำเภอ!",
                      },
                    ]}
                  >
                    <Select
                      className="antd-Selected"
                      disabled={isDisable.city2}
                      placeholder="District/เขต/อำเภอ"
                      onChange={(e) => {
                        fromCreatePersonnel.setFieldsValue({
                          subCity2: null,
                          postalCode2: null,
                        });
                        getSubCities(e, "addPresent");
                        getPostalCodes(e, "addPresent");
                        setIsDisable({
                          ...isDisable,
                          subCity2: false,
                          postalCode2: true,
                        });
                      }}
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {citiesOpt1}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="subCity2"
                    rules={[
                      {
                        required: !isDisable.subCity,
                        message: "กรุณากรอก Sub-district/แขวง/ตำบล!",
                      },
                    ]}
                  >
                    <Select
                      className="antd-Selected"
                      disabled={isDisable.subCity2}
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      placeholder="Sub-district/แขวง/ตำบล"
                      onChange={(e) => {
                        fromCreatePersonnel.setFieldsValue({
                          postalCode2: null,
                        });
                        setIsDisable({
                          ...isDisable,
                          postalCode2: false,
                        });
                      }}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {subCitiesOpt1}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]} style={{ paddingTop: "20px" }}>
                <Col span={6}>
                  <Form.Item
                    name="postalCode2"
                    rules={[
                      {
                        required: !isDisable.subCity,
                        message: "กรุณากรอก Postal Code/รหัสไปรษณีย์!",
                      },
                    ]}
                  >
                    <Select
                      className="antd-Selected"
                      disabled={isDisable.postalCode2}
                      placeholder="Postal Code/รหัสไปรษณีย์"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {postalCodesOpt1}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="country2"
                    rules={[validate("Country/ประเทศ")]}
                  >
                    <Select
                      className="antd-Selected"
                      placeholder="Country/ประเทศ"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optCountry}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </div>

        <div className="create-page-password" style={{ padding: "30px 30px" }}>
          <div className="title-header">
            <h3>Login Information</h3>
          </div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item name="permission" rules={[validate("User Group")]}>
                <Select
                  className="antd-Selected"
                  placeholder="User Group"
                  style={{ width: "100%" }}
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optUserGroup}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="username" rules={[validate("username")]}>
                <Input
                  className="input-personnel"
                  placeholder="Username (xxxxx_xxx.) "
                  onKeyDown={(e: any) => {
                    onKeydownCheckSpaceBar(e);
                  }}
                ></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col span={12}>
              <Form.Item name="password" rules={[validate("password")]}>
                <Input.Password
                  className="inputpass-personnel"
                  placeholder="Password"
                  iconRender={(visible) =>
                    visible ? (
                      <EyeFilled style={{ color: "#4d7e7f" }} />
                    ) : (
                      <EyeInvisibleFilled style={{ color: "#4d7e7f" }} />
                    )
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="confirmPassword"
                rules={[validate("confirmPassword")]}
              >
                <Input.Password
                  className="inputpass-personnel"
                  placeholder="Confirm Password"
                  iconRender={(visible) =>
                    visible ? (
                      <EyeFilled style={{ color: "#4d7e7f" }} />
                    ) : (
                      <EyeInvisibleFilled style={{ color: "#4d7e7f" }} />
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <div className="row justify-content-around">
            <div className="col-6">
              <SelectModel
                placeholder="User Group"
                option={optionGroup}
                // onChange={(e) => setUserGroup(e.target.value)}
              />
            </div>
            <div className="col-6">
              <Inputold
                placeholder="Username"
                // value={isUserName}
                // onChange={(e) => setUserName(e.target.value)}
              />
            </div>
            <div className="col-6">
              <Inputold
                placeholder="Password"
                type="text"
                // value={isPassWord}
                // onChange={(e) => setPassWord(e.target.value)}
              />
            </div>
            <div className="col-6">
              <Inputold
                placeholder="Confirm Password"
                type="text"
                // value={isConFirm}
                // onChange={(e) => setConFirm(e.target.value)}
              />
            </div>
          </div> */}
        </div>

        {/* <div className="justify-center mt-20">
          <MainButton
            className="mg-10"
            background="#E76464"
            title="ยกเลิก/Cancel"
          />
          <MainButton
            className="mg-10"
            title="บันทึกข้อมูล/Submit"
            onClick={() => {
              setIsOpen(true);
              setTextModal(status);
              createPersonnel();
            }}
          />
        </div> */}
        <Row
          className="button-personnelCreate"
          justify="center"
          style={{ marginTop: "10px" }}
        >
          <Col>
            <Space>
              <Button
                onClick={() => {
                  history.push(`/setting/personnel`);
                  // fromCreatePersonnel.resetFields();
                }}
                className="cancleButton-personnelCreate"
              >
                กลับ/Back
              </Button>
              <Button
                className="confirmButton-personnelCreate"
                htmlType="submit"
                onClick={() => {
                  // if (type === "update") {
                  //   update();
                  // }
                }}
              >
                บันทึกข้อมูล/Submit
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default PersonnelcreateNew;
